import Vue from 'vue'
import Snotify, { SnotifyPosition } from 'vue-snotify'

Vue.use(Snotify, {
  toast: {
    timeout: 8000,
    showProgressBar: false,
    position: SnotifyPosition.rightTop
  }
})
